/**
 * End User web app module resolver — O(1) cached left-nav module resolution.
 */
(function (global) {
    'use strict';

    var cachedModule = { module: 'Others', moduleTranslated: 'Others' };
    var entityMap = {};
    var groupMap = {};
    var groupIconMap = {};
    var topNavMap = {};
    var observer = null;
    var quickLinksNode = null;

    function warn(message) {
        if (typeof console !== 'undefined' && console.warn) {
            console.warn('[EndUserWebModuleResolver] ' + message);
        }
    }

    function parseSideLayoutData(raw) {
        if (!raw) {
            return null;
        }
        if (typeof raw === 'string') {
            try {
                return JSON.parse(raw);
            } catch (e) {
                return null;
            }
        }
        return raw;
    }

    function buildMaps(sideLayoutData) {
        entityMap = {};
        groupMap = {};
        groupIconMap = {};
        topNavMap = {};

        var data = sideLayoutData && sideLayoutData.data ? sideLayoutData.data : sideLayoutData;
        if (!data) {
            return;
        }

        var entityList = data.entityList || (data.rightSideBar && data.rightSideBar.entityList) || [];
        entityList.forEach(function (entity) {
            if (entity && entity.listId != null) {
                entityMap[String(entity.listId)] = {
                    module: entity.defaultName || entity.label || 'Others',
                    moduleTranslated: entity.label || entity.defaultName || 'Others'
                };
            }
        });

        var groups = data.groups || (data.rightSideBar && data.rightSideBar.groups) || [];
        groups.forEach(function (group) {
            if (group && group.id != null) {
                var groupEntry = {
                    module: group.name || group.displayName || 'Others',
                    moduleTranslated: group.displayName || group.name || 'Others'
                };
                groupMap[String(group.id)] = groupEntry;
                if (group.iconPath) {
                    groupIconMap[group.iconPath] = groupEntry;
                }
            }
        });

        var navigationTabs = (data.headerBar && data.headerBar.navigationTabs) || data.navigationTabs || [];
        navigationTabs.forEach(function (tab) {
            if (tab && tab.defaultName) {
                topNavMap[tab.defaultName.toLowerCase()] = {
                    module: tab.defaultName,
                    moduleTranslated: tab.label || tab.defaultName
                };
            }
        });
    }

    function isNavHidden() {
        if (typeof document === 'undefined') {
            return true;
        }
        if (document.body && (
            document.body.classList.contains('mobile_view') ||
            document.body.classList.contains('embed-results-only')
        )) {
            return true;
        }
        var quickLinks = document.getElementById('quick_links');
        if (!quickLinks) {
            return true;
        }
        var style = window.getComputedStyle(quickLinks);
        return style.display === 'none' || style.visibility === 'hidden';
    }

    function lookupEntityByListId(listId) {
        return entityMap[String(listId)] || null;
    }

    function recomputeModule() {
        if (isNavHidden()) {
            cachedModule = { module: 'Others', moduleTranslated: 'Others' };
            return cachedModule;
        }

        if (typeof document === 'undefined') {
            cachedModule = { module: 'Others', moduleTranslated: 'Others' };
            return cachedModule;
        }

        var selectedLink = document.querySelector('#quick_links a.goto-items-selected[list-id]');
        if (selectedLink) {
            var selected = lookupEntityByListId(selectedLink.getAttribute('list-id'));
            if (selected) {
                cachedModule = selected;
                return cachedModule;
            }
        }

        var entityOneLink = document.querySelector('#quick_links li.active.current-open-list > a.group_link.entity-one.active, #quick_links li.active.current-open-list > a.entity-one.active');
        if (entityOneLink) {
            var entityId = entityOneLink.getAttribute('id');
            if (entityId && entityId.indexOf('entity_node_') === 0) {
                var entityListId = entityId.replace('entity_node_', '');
                var entityMatch = lookupEntityByListId(entityListId);
                if (entityMatch) {
                    cachedModule = entityMatch;
                    return cachedModule;
                }
            }
        }

        var openCategory = document.querySelector('#quick_links li.cat-list.active.current-open-list');
        if (openCategory && !selectedLink) {
            var categoryLink = openCategory.querySelector('a.group_link');
            if (categoryLink) {
                var iconEl = categoryLink.querySelector('i');
                if (iconEl) {
                    var iconClasses = iconEl.className.split(/\s+/);
                    for (var i = 0; i < iconClasses.length; i++) {
                        var iconMatch = groupIconMap[iconClasses[i]];
                        if (iconMatch) {
                            cachedModule = iconMatch;
                            return cachedModule;
                        }
                    }
                }
            }
        }

        var activeTopNav = document.querySelector('#quick_links ul.global-link li.topNavs.active');
        if (activeTopNav) {
            var topNavLink = activeTopNav.querySelector('a.group_link i');
            if (topNavLink) {
                var iconClasses = topNavLink.className.split(/\s+/);
                for (var j = 0; j < iconClasses.length; j++) {
                    if (iconClasses[j].indexOf('icon-') === 0) {
                        var defaultName = iconClasses[j].replace('icon-', '');
                        var topMatch = topNavMap[defaultName.toLowerCase()];
                        if (topMatch) {
                            cachedModule = topMatch;
                            return cachedModule;
                        }
                    }
                }
            }
            var labelNode = activeTopNav.querySelector('.label');
            if (labelNode) {
                cachedModule = {
                    module: labelNode.textContent.trim() || 'Others',
                    moduleTranslated: labelNode.textContent.trim() || 'Others'
                };
                return cachedModule;
            }
        }

        cachedModule = { module: 'Others', moduleTranslated: 'Others' };
        return cachedModule;
    }

    function initModuleResolver(options) {
        options = options || {};
        var sideLayoutData = options.sideLayoutData;

        if (!sideLayoutData && typeof localStorage !== 'undefined') {
            sideLayoutData = parseSideLayoutData(localStorage.getItem('sideLayoutData'));
        } else {
            sideLayoutData = parseSideLayoutData(sideLayoutData);
        }

        buildMaps(sideLayoutData);
        recomputeModule();

        if (typeof MutationObserver !== 'undefined' && typeof document !== 'undefined') {
            quickLinksNode = document.getElementById('quick_links');
            if (quickLinksNode) {
                if (observer) {
                    observer.disconnect();
                }
                observer = new MutationObserver(function () {
                    recomputeModule();
                });
                observer.observe(quickLinksNode, {
                    attributes: true,
                    attributeFilter: ['class'],
                    subtree: true,
                    childList: false
                });
            }
        }

        return cachedModule;
    }

    function getModule() {
        return cachedModule;
    }

    function refreshModuleMaps(sideLayoutData) {
        buildMaps(parseSideLayoutData(sideLayoutData));
        recomputeModule();
    }

    function destroyModuleResolver() {
        if (observer) {
            observer.disconnect();
            observer = null;
        }
        quickLinksNode = null;
        entityMap = {};
        groupMap = {};
        groupIconMap = {};
        topNavMap = {};
        cachedModule = { module: 'Others', moduleTranslated: 'Others' };
    }

    global.EndUserWebModuleResolver = {
        init: initModuleResolver,
        getModule: getModule,
        refresh: refreshModuleMaps,
        destroy: destroyModuleResolver,
        isNavHidden: isNavHidden,
        __testHooks: {
            buildMaps: buildMaps,
            recomputeModule: recomputeModule,
            setDocument: function () { /* reserved for tests */ },
            getCachedModule: function () { return cachedModule; },
            setCachedModule: function (value) { cachedModule = value; },
            getEntityMap: function () { return entityMap; }
        }
    };
})(typeof window !== 'undefined' ? window : global);
